import { isMobile } from "../../../js/modules/utilities";

const container = document.querySelector('.interactive-chart > .container');
const chartItems = document.querySelectorAll('.chart-item');
const contentItems = document.querySelectorAll('.chart-content');
const contentNav = document.querySelectorAll('.content-nav');

const containerHgt = container ? container.getBoundingClientRect().height : 0;
const windowHgt = window.innerHeight;
const scrollFrameTop = ((windowHgt - containerHgt) / 2) - 20;
const scrollFrameBottom = windowHgt - scrollFrameTop + 20;

const targetMax = 0;
const targetMin = -15;
const switchAt = 5;

let scrollStart = 0;
let lockScroll = false;
let targetScroll = targetMax;
let activeChart = 0;
let maxChart = contentItems.length - 1;

export const sustainabilityChart = () => {
  chartItems.forEach((item) => {
    item.addEventListener('click', chartClickHandler);
  });

  if(!isMobile) window.addEventListener('scroll', scrollHandler);

  if(isMobile) initNav();
}

const scrollHandler = () => {
  if(!container) return;
  if(!lockScroll && container.getBoundingClientRect().top >= scrollFrameTop && container.getBoundingClientRect().bottom <= scrollFrameBottom) {
    lockScroll = true;
    scrollStart = window.scrollY;
    console.log('lock now!');
    document.querySelector('body').classList.add('scroll-lock');
    document.addEventListener('wheel', handleScroll);
  }
}

const handleScroll = (e) => {
  let x = Math.abs(e.deltaY / 100);
  targetScroll = e.deltaY > 0 ? targetScroll - x : targetScroll + x;

  if(chartItems[Math.abs(targetScroll) / switchAt]) {
    switchChart(chartItems[Math.abs(targetScroll) / switchAt]);
  }

  if (targetScroll > targetMax) {
    resetLock(targetMax);
  } else if (targetScroll < targetMin) {
    resetLock(targetMin);
  } else {
    e.preventDefault();
  }
};

const resetLock = (scrollAmount) => {
  targetScroll = scrollAmount;
  document.querySelector('body').classList.remove('scroll-lock');
  document.removeEventListener('wheel', handleScroll);
  lockScroll = false;
}

const chartClickHandler = (e) => {
  const target = e.currentTarget;
  switchChart(target);
}

const switchChart = (target) => {
  chartItems.forEach((item) => {
    item.classList.remove('active');
  });

  contentItems.forEach((item) => {
    if(item.classList.contains(target.dataset.content)) {
      item.classList.add('active');
    } else {
      item.classList.remove('active');
    }
  });

  target.classList.add('active');
}

const initNav = () => {
  contentNav.forEach((nav) => {
    nav.addEventListener('click', navClickHandler);
  });
}

const navClickHandler = (e) => {
  if(e.currentTarget.classList.contains('next')) {
    if(activeChart < maxChart) {
      activeChart++;
    } else {
      activeChart = 0;
    }
  } else {
    if(activeChart > 0) {
      activeChart--;
    } else {
      activeChart = maxChart;
    }
  };

  switchChart(chartItems[activeChart]);
}



// WEBPACK FOOTER //
// ./src/templates/components/sustainability-chart/sustainability-chart.js